module.exports = __webpack_public_path__ + "static/media/packages.68ae3f26.png";